import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { DocumentUpdate } from '../../services';

export const fetchDocumentUpdate = createAsyncThunk(
    'documentUpdate/fetchDocumentUpdate',
    async ({ id, file, title, slug, description, content, sort }) => {
        const response = await DocumentUpdate(id, file, title, slug, description, content, sort);
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const documentUpdateSlice = createSlice({
    name: 'documentUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDocumentUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchDocumentUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default documentUpdateSlice.reducer;
